@import '../styles/fonts.scss';

.buttonContainer {
  display: flex;
  float: right;
  margin-bottom: 30px;
  padding-top: 16px;

  button {
    margin: 0 10px;
  }
}

.classCell {
  width: 25ch;
}

.checkbox {
  display: flex;
  position: relative;
  top: 0.2em;
}
